// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "span[data-v-06b82547]{font-size:inherit}.external-link[data-v-06b82547]{max-width:900px;width:100%;margin-left:auto;margin-right:auto}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
